var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"open-app"},[_c('van-overlay',{attrs:{"show":_vm.show,"z-index":"99999"},on:{"click":function($event){_vm.show = false}}},[_c('img',{staticStyle:{"width":"100%","margin-left":"0"},attrs:{"src":require("@/assets/live_weixin.png"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }